import React, { useState, useEffect, useRef } from "react";
import {
  FiX,
  FiUser,
  FiLogOut,
  FiCopy,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { MdRefresh } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuth } from "../../context/auth";
import ThemeToggleLeft from "../jsstyle/ThemeToggleLeft";
import { useWebSocket } from "../../context/UseWebSocketContext";
import { logoutService } from "../apiservice/logoutService";
import { toast } from "react-toastify";
import { secKeyRefreshService } from "../apiservice/secKeyRefreshService";
import { sendGlobalWS } from "../../context/UseWebSocketContext";
import TradeCopier from "./TradeCopier";
import AlgoPilot from "./AlgoPilot";
import Payment from "./Payment";
import { FaCopy } from "react-icons/fa";
import { FaRobot } from "react-icons/fa";
import { MdCurrencyRupee } from "react-icons/md";
import { HiDocumentText } from "react-icons/hi";
import { SideBarpennel } from "./SideBarpennel";
import { AiOutlineExpandAlt } from "react-icons/ai";
import { GoSidebarCollapse } from "react-icons/go";
import Workspace from "./Workspace";
import { tradingService } from "../apiservice/tradingService";
import { useTheme } from "../../context/ThemeContext";

const Dashboard = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [show, setShow] = useState(false);
  // const [selectedAccount, setSelectedAccount] = useState("default");
  const [selectedAccount, setSelectedAccount] = useState("demo");
  const [showAddPanel, setShowAddPanel] = useState(true);
  const { darkMode, setDarkMode } = useTheme();
  const [profileStatus, setProfileStatus] = useState({ trading_status: false });
  const [refreshing, setRefresing] = useState(false);
  const [secKey, setSecKey] = useState([]);

  const [showTradeCopier, setShowTradeCopier] = useState(false);
  const [showAlgoPilot, setShowAlgoPilot] = useState(false);
  const [showPayment, setShowPayment] = useState(false);

  const navigate = useNavigate();
  const { getLoginToken, getGoogleAuthToken, storeSecKey } = useAuth();
  const { wsData, balance, logoutCleanup, closeWebSocket } = useWebSocket();

  const profile = wsData || {};
  const bdata = balance || {};
  const token = getLoginToken() || getGoogleAuthToken();
  const refCode = profile.my_referral_code;
  const signupUrl = `https://api.algocontroller.com/v1/sign-up?ref=${refCode}`;

  const popupRef = useRef(null);
  const profRef = useRef(null);
  const balanceRef = useRef(null);
  const tradeCopierRef = useRef(null);
  const algoPilotRef = useRef(null);
  const paymentRef = useRef(null);

  const toggleShowMore = () => setShowMore((prev) => !prev);

  // ✅ SECURITY KEY SYNC FROM WEBSOCKET
  useEffect(() => {
    if (profile?.sec_key && profile.sec_key !== "undefined" && profile.sec_key !== "null" && profile.sec_key.length > 10) {
      localStorage.setItem("sec_key", profile.sec_key);
      storeSecKey(profile.sec_key);
      console.log("✅ Security key synced from Dashboard:", profile.sec_key.substring(0, 15) + "...");
    }
  }, [profile?.sec_key, storeSecKey]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowAddPanel(false);
      } else {
        setShowAddPanel(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tradeCopierRef.current && !tradeCopierRef.current.contains(event.target)) {
        setShowTradeCopier(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (algoPilotRef.current && !algoPilotRef.current.contains(event.target)) {
        setShowAlgoPilot(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (paymentRef.current && !paymentRef.current.contains(event.target)) {
        setShowPayment(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowProfile(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (profRef.current && !profRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (balanceRef.current && !balanceRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePauseClick = async () => {
    const newPauseState = !profileStatus.trading_status;
    try {
      const result = await tradingService(token, newPauseState);
      if (!result.error) {
        setProfileStatus({ trading_status: newPauseState });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(signupUrl);
      toast.success("Referral link copied!");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const handleLogout = async () => {
    setIsLoggingOut(true);
    localStorage.clear();
    sessionStorage.clear();
    if (logoutCleanup) logoutCleanup();
    if (closeWebSocket) closeWebSocket();
    const token = getLoginToken() || getGoogleAuthToken();
    if (token) {
      logoutService(token).catch(err => console.error("Logout API error:", err));
    }
    toast.success("Logged out successfully");
    setTimeout(() => {
      navigate("/login", { replace: true });
    }, 300);
    setIsLoggingOut(false);
  };

  const handleRefreshKey = async () => {
    const token = getLoginToken() || getGoogleAuthToken();
    try {
      setRefresing(true);
      const response = await secKeyRefreshService(token);
      if (response.success && response.status === 200) {
        toast.success(response?.data?.data);
        const newSecKey = response.data?.data;
        setSecKey(newSecKey);
        if (newSecKey && newSecKey !== "undefined" && newSecKey !== "null") {
          localStorage.setItem("sec_key", newSecKey);
          storeSecKey(newSecKey);
          console.log("✅ Security key refreshed:", newSecKey.substring(0, 15) + "...");
        }
        sendGlobalWS({ r: "profile" });
      } else {
        toast.error(response?.data?.data);
      }
      setTimeout(() => setRefresing(false), 3000);
    } catch (error) {
      console.error("error", error?.response);
    } finally {
      setRefresing(false);
    }
  };

  const navItems = [
    { name: "TradeCopier", icon: FaCopy, onClick: () => setShowTradeCopier(true) },
    { name: "AlgoPilot", icon: FaRobot, onClick: () => setShowAlgoPilot(true) },
    { name: "Payment", icon: MdCurrencyRupee, onClick: () => setShowPayment(true) },
    { name: "Doc", to: "https://algocontroller.com/doc", icon: HiDocumentText, isExternal: true },
  ];

  const bgColor = darkMode ? 'bg-[#0D1117]' : 'bg-white';
  const navbarBg = darkMode ? 'bg-black backdrop-blur-xl border-b border-[#30363D] shadow-lg shadow-black/20' : 'bg-white/95 backdrop-blur-xl border-b border-gray-200 shadow-lg shadow-gray-200/50';
  const textColor = darkMode ? 'text-gray-200' : 'text-gray-700';
  const textMuted = darkMode ? 'text-gray-400' : 'text-gray-500';
  const borderColor = darkMode ? 'border-[#30363D]' : 'border-gray-200';
  const hoverBg = darkMode ? 'hover:bg-[#21262D]' : 'hover:bg-gray-100';
  const hoverText = darkMode ? 'hover:text-blue-400' : 'hover:text-blue-600';
  const cardBg = darkMode ? 'bg-[#161B22]' : 'bg-white';
  const popupBg = darkMode ? 'bg-[#1d1d1f]' : 'bg-white';

  return (
    <div className={`h-screen w-screen overflow-hidden ${bgColor} transition-all duration-300`}>
      <nav className={`fixed top-0 left-0 right-0 h-[35px] z-50 px-6 transition-all duration-300 ${navbarBg}`}>
        <div className="w-full flex justify-between items-center h-full">
          <div className="flex gap-2 items-center">
            <button 
              className={`p-2 rounded-lg transition-all duration-300 ${hoverBg} ${textColor}`}
              onClick={() => setShowAddPanel((prev) => !prev)}
              title={showAddPanel ? "Collapse Sidebar" : "Expand Sidebar"}
            >
              {showAddPanel ? <GoSidebarCollapse size={20} /> : <AiOutlineExpandAlt size={20} />}
            </button>

            {navItems.map((item) => {
              const Icon = item.icon;
              if (item.isExternal) {
                return (
                  <a key={item.name} href={item.to} target="_blank" rel="noopener noreferrer" 
                    className={`p-2 rounded-lg transition-all duration-200 ${hoverBg} ${textColor} ${hoverText}`}
                    title={item.name}>
                    <Icon size={16} />
                  </a>
                );
              } else {
                return (
                  <button key={item.name} onClick={item.onClick} 
                    className={`p-2 rounded-lg transition-all duration-200 ${hoverBg} ${textColor} ${hoverText}`}
                    title={item.name}>
                    <Icon size={16} />
                  </button>
                );
              }
            })}
          </div>

          <div className="flex items-center gap-3">
            <div className="relative">
              <button 
                onClick={() => setShow(!show)}
                className={`px-2 py-1 rounded-md transition-all duration-200 font-sans font-bold text-sm 
                  ${darkMode ? 'bg-gray-800/50 hover:bg-gray-800 text-gray-200 border border-gray-700' : 'bg-transparent hover:bg-gray-100 text-gray-700 border border-gray-200'}`}
              >
                <div className="flex items-center gap-2">
                  <span className="text-xs opacity-70">₹</span>
                  <span className="font-bold">
                    {selectedAccount === "demo" && bdata.balance}
                    {selectedAccount === "alter" && 5000}
                    {selectedAccount === "default" && bdata.balance}
                  </span>
                </div>
              </button>

              {show && (
                <div ref={balanceRef}
                  className={`absolute z-50 top-full mt-2 right-0 min-w-[130px] rounded-lg overflow-hidden shadow-2xl animate-in fade-in slide-in-from-top-2 duration-200
                    ${darkMode ? 'bg-gray-800/95 backdrop-blur-xl border-gray-700' : 'bg-white/95 backdrop-blur-xl border border-gray-200'}`}>
                  <div className="p-1">
                    {[{ id: "demo", name: "Demo", balance: bdata.balance }].map((account) => (
                      <label key={account.id}
                        className={`flex items-center p-1 rounded-lg cursor-pointer transition-all duration-200
                          ${selectedAccount === account.id ? (darkMode ? 'bg-blue-500/20' : 'bg-blue-50') : (darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50')}`}>
                        <input type="radio" name="account" value={account.id}
                          checked={selectedAccount === account.id}
                          onChange={() => setSelectedAccount(account.id)}
                          className="w-4 h-4 text-blue-500 focus:ring-blue-500" />
                        <div className="ml-1 flex-1">
                          <div className={`font-sans ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>{account.name}</div>
                          <div className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>₹{account.balance}</div>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="relative">
              <button onClick={() => setDropdownOpen(!dropdownOpen)}
                className={`w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-105
                  bg-gradient-to-br from-blue-500 to-purple-600 shadow-lg ${darkMode ? 'shadow-blue-500/25' : 'shadow-md'}`}>
                <span className="text-white text-sm font-semibold">
                  {profile?.mail?.charAt(0).toUpperCase() || "?"}
                </span>
              </button>

              {dropdownOpen && (
                <div ref={profRef}
                  className={`absolute right-0 mt-3 w-56 rounded-xl overflow-hidden shadow-2xl animate-in fade-in slide-in-from-top-2 duration-200
                    ${darkMode ? 'bg-gray-800/95 backdrop-blur-xl border border-gray-700' : 'bg-white/95 backdrop-blur-xl border border-gray-200'}`}>
                  <button onClick={() => { setShowProfile(true); setDropdownOpen(false); }}
                    className={`flex items-center w-full px-4 py-3 text-sm transition-colors duration-200 ${hoverBg} ${textColor}`}>
                    <FiUser className="w-4 h-4 mr-3" /> Profile
                  </button>
                  <div className={`flex items-center px-4 py-3 text-sm w-full ${hoverBg} ${textColor}`}>
                    <ThemeToggleLeft darkMode={darkMode} setDarkMode={setDarkMode} />
                  </div>
                  <button onClick={handleLogout} disabled={isLoggingOut}
                    className={`flex items-center w-full px-4 py-3 text-sm transition-colors duration-200 ${isLoggingOut ? 'opacity-50 cursor-not-allowed' : ''} ${hoverBg} ${textColor}`}>
                    {isLoggingOut ? (
                      <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-3"></div>
                    ) : (
                      <FiLogOut className="w-4 h-4 mr-3" />
                    )}
                    {isLoggingOut ? "Logging out..." : "Logout"}
                  </button>
                  <div className={`px-4 py-3 text-xs flex items-center justify-between ${darkMode ? 'bg-black/30 text-gray-400 border-t border-gray-700' : 'bg-gray-50 text-gray-500 border-t border-gray-200'}`}>
                    <strong>Expiry Date:</strong> <span className="font-mono">{profile.expiry || "xxxxxxx"}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      <main className="pt-[35px]">
        <div className="flex h-[calc(100vh-35px)]">
          <SideBarpennel
            showAddPanel={showAddPanel}
            setShowAddPanel={setShowAddPanel}
            profileStatus={profileStatus}
            handlePauseClick={handlePauseClick}
            darkMode={darkMode}
          />

          <div className="flex-1 overflow-hidden">
            <Workspace 
              darkMode={darkMode} 
              showAddPanel={showAddPanel}
            />
          </div>
        </div>
      </main>

      {showProfile && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div ref={popupRef} className={`relative w-96 rounded-2xl p-4 text-center shadow-xl ${popupBg} border ${borderColor}`}>
            <button className="absolute top-2 right-4 text-gray-500 hover:text-gray-800" onClick={() => setShowProfile(false)}>
              <FiX className="w-5 h-5" />
            </button>
            <div className={`w-20 h-20 mx-auto rounded-full overflow-hidden shadow-md border-4 border-white bg-gray-700 ${darkMode ? 'bg-gray-600' : 'bg-gray-500'} flex items-center justify-center text-3xl font-bold text-white`}>
              {profile?.mail?.charAt(0).toUpperCase() || "?"}
            </div>
            <div className={`text-sm mt-2 ${textColor}`}>
              <p><strong>Email:</strong> {profile.mail || "xxxxxxx"}</p>
              <p><strong>Account Type:</strong> {profile.account_type || "xxxxxxx"}</p>
            </div>
            {showMore && (
              <div className={`text-xs bg-black/5 dark:bg-white/5 p-2 rounded-md mt-4 ${textMuted}`}>
                <p className="mt-2"><strong>Expiry Date:</strong> {profile.expiry || "xxxxxxx"}</p>
                <p><strong>Trading Status:</strong> {profile.trading_pause ? "Inactive" : "Active"}</p>
                <p><strong>Trading Block:</strong> {profile.trading_block ? "True" : "False"}</p>
                <div className="flex justify-center gap-2">
                  <p><strong>Security Key:</strong> {profile.sec_key || ""}</p>
                  <MdRefresh onClick={handleRefreshKey} className={`cursor-pointer transition-transform duration-500 ${refreshing ? 'animate-spin' : ''}`} size={15} />
                </div>
                <div className="flex justify-center gap-2">
                  <p><strong>Referral Code:</strong> {profile.my_referral_code || "xxxxxxx"}</p>
                  <FiCopy onClick={handleCopy} className="cursor-pointer" size={15} />
                </div>
              </div>
            )}
            <button onClick={toggleShowMore} className={`mt-2 px-4 py-2 rounded-full shadow hover:opacity-90 transition ${darkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800'}`}>
              {showMore ? "Show Less" : "Show More"}
            </button>
          </div>
        </div>
      )}

      {showTradeCopier && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div ref={tradeCopierRef} className={`relative h-[95%] w-[95%] rounded-xl shadow-2xl overflow-hidden ${cardBg}`}>
            <div className={`flex items-center justify-between px-6 py-3 border-b ${borderColor} ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
              <h2 className={`text-lg font-semibold ${textColor}`}>Trade Copier</h2>
              <button onClick={() => setShowTradeCopier(false)} className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
                <FiX size={20} className={textMuted} />
              </button>
            </div>
            <div className="h-[calc(100%-60px)] overflow-y-auto">
              <TradeCopier />
            </div>
          </div>
        </div>
      )}

      {showAlgoPilot && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div ref={algoPilotRef} className={`relative h-[95%] w-[95%] rounded-xl shadow-2xl overflow-hidden ${cardBg}`}>
            <div className={`flex items-center justify-between px-6 py-3 border-b ${borderColor} ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
              <h2 className={`text-lg font-semibold ${textColor}`}>Algo Pilot</h2>
              <button onClick={() => setShowAlgoPilot(false)} className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
                <FiX size={20} className={textMuted} />
              </button>
            </div>
            <div className="h-[calc(100%-60px)] overflow-y-auto p-4">
              <AlgoPilot />
            </div>
          </div>
        </div>
      )}

      {showPayment && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div ref={paymentRef} className={`relative h-[95%] w-[95%] rounded-xl shadow-2xl overflow-hidden ${cardBg}`}>
            <div className={`flex items-center justify-between px-6 py-3 border-b ${borderColor} ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
              <h2 className={`text-lg font-semibold ${textColor}`}>Payment & Plans</h2>
              <button onClick={() => setShowPayment(false)} className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
                <FiX size={20} className={textMuted} />
              </button>
            </div>
            <div className="h-[calc(100%-60px)] overflow-y-auto p-4">
              <Payment />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;